export default {"src":"/_next/static/media/clever.bb7498f2.svg","height":826,"width":831,"blurWidth":0,"blurHeight":0};